module.exports = __webpack_public_path__ + "img/group23-th.0dfacd66.png";